import Vue from 'vue'
import WhereAmI from '@dp/whereami'
import store from './vuex/store';
// import '@dp/hippo';
import BaseEnv from '@dp/base-env';
import Url from '@dp/base-op-url';
import KNB from '@dp/knb';
let getUA = require('@dp/util-m-ua');
const ua = getUA();
let appName = 'm';

if(ua.type == 'dp') {
  appName = 'dp'
} else if(ua.type == 'mtgroup') {
  appName = 'mt'
} else if(ua.source = 'dianping') {
  appName = 'dp'
} else  if(ua.source = 'meituan') {
  appName = 'mt'
}

let render = (cityData, locationData, userData, extendData, component, inApp) => {
  let url = new Url(location.href);
  let brandId = url.search('brandId');
  //把常用的环境属性mixin
  let passData = Object.assign({}, extendData, {
    cityId: cityData.cityId,
    lat: locationData.lat,
    lng: locationData.lng,
    brandId: brandId,
    uuid: userData.uuid,
    userId: userData.userId,
    token: userData.token,
    cx: userData.cx,
    appName: userData.type || appName,
    // appName: 'mt',
    inApp: inApp
  });

  Vue.mixin({
    data() {
      return passData
    },
    methods: {
      baseEnv: BaseEnv
    }
  });

  //渲染入口
  new Vue({
    store,
    el: document.getElementById("container"),
    components: {
      'app': component
    }
  });

};

let locate = (userData, extendData, component, inApp) => {
  WhereAmI.config({
    timeout: 1000,
    city: true
  });
  WhereAmI((result) => {
    let cityData = {
      cityId: result.city.cityid,
      cityName: result.city.cityname
    };
    let locationData = {
      lat: result.lat,
      lng: result.lng
    }
    render(cityData, locationData, userData, extendData, component, inApp);
  }, function () {
    render({cityId: 1}, {lat: 31.2177853, lng: 121.4158524}, userData, extendData, component, inApp);
  });
}


export const facadeBase = (component, extendData) => {
  KNB.getFingerprint({
    success(e) {
      KNB.getUserInfo({
        success(e){
          let userData = {
            type: e.type,
            userId: e.userId,
            uuid: e.uuid,
            token: e.token
          };
          locate(userData, extendData, component, true);
          console.log(e);
        },
        fail(){
          let userData = {
            type: 'm'
          };
          locate(userData, extendData, component, false);
        }
      });
    },
    fail() {
      KNB.getUserInfo({
        success(e){
          let userData = {
            type: e.type,
            userId: e.userId,
            uuid: e.uuid,
            token: e.token,
            cx: ''
          };
          locate(userData, extendData, component, true);
          console.log(e);
        },
        fail(){
          let userData = {
            type: 'm',
            userId: '',
            uuid: '',
            token: '',
            cx: ''
          };
          locate(userData, extendData, component, false);
        }
      });
    }
  });

}



// WEBPACK FOOTER //
// ./src/base.js